export default __webpack_public_path__ + "static/media/27-bm.b10d9951.webp";